import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { IRegionConfig } from '../../../../types';
import { useTranslation } from "react-i18next";

interface Props {
  config: IRegionConfig;
  showRisks: boolean;
  visaSupport?: string;
  riskList?: string[];
}

function VisaSupport({ config, showRisks, visaSupport, riskList = [] }: Props) {
    const { t } = useTranslation('forms.visa');
  const visaSupportConfig = config.Checklist.PersonalInfo.Page9.VisaSupport;

  return (
    <>
      {visaSupport && (
        <SummaryRow
          key="visaSupport"
          label={t('forms.visa:enrolyVisaSupport')}
          fullLabel={visaSupportConfig?.label}
          value={visaSupport}
          isRisk={showRisks && riskList.includes(Q.VISA_SUPPORT)}
        />
      )}
    </>
  );
}

export default VisaSupport;
